export default {
    state: {
        isHamburgerMenu: false
    },
    getters: {
        isHamburgerMenuStore: state => state.isHamburgerMenu
    },
    actions: {
        showHamburgerMenuStore({ commit }) {
            commit('SHOW_HAMBURGER_MENU')
        },
        closeHamburgerMenuStore({ commit }) {
            commit('CLOSE_HAMBURGER_MENU')
        }
    },
    mutations: {
        SHOW_HAMBURGER_MENU(state) {
            state.isHamburgerMenu = true
        },
        CLOSE_HAMBURGER_MENU(state) {
            state.isHamburgerMenu = false
        }
    }
}
